import React from 'react';
import { motion } from 'framer-motion';
import { Send, ExternalLink, Building2 } from 'lucide-react';
export function CtaBanner() {
  return <section className="py-20 px-4 relative z-10" data-id="element-27">
      <div className="max-w-5xl mx-auto" data-id="element-28">
        <motion.div className="gradient-animate rounded-3xl p-10 md:p-16 text-center relative overflow-hidden shadow-[0_0_40px_rgba(233,30,140,0.4)]" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          {/* Inner dark overlay to make text readable */}
          <div className="absolute inset-1 bg-dark-bg/90 rounded-[22px] z-0" data-id="element-30"></div>

          <div className="relative z-10" data-id="element-31">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-32">
              立即加入
              <span className="text-pink-primary neon-glow" data-id="element-33">芽笼777</span>
              <br data-id="element-34" />
              开启您的专属体验
            </h2>
            <p className="text-lg text-gray-300 mb-10" data-id="element-35">
              Join Geylang777 Today for Your Exclusive Experience
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-36">
              <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="neon-btn flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-bold text-lg" data-id="element-37">
                <Send size={20} data-id="element-38" />
                加入Telegram频道
              </a>

              <a href="https://geylang777-6.site" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-bold text-lg border-2 border-pink-primary hover:bg-pink-primary/20 transition-colors" data-id="element-39">
                <ExternalLink size={20} data-id="element-40" />
                进入官方网站
              </a>

              <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-bold text-lg border-2 border-pink-primary hover:bg-pink-primary/20 transition-colors" data-id="element-41">
                <Building2 size={20} data-id="element-42" />
                新加坡春风阁
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}